/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostSegmentPathParams = NonNullable<operations['postSegment']['parameters']['path']>;

export type PostSegmentRequestBody = OperationRequestBodyContent<operations['postSegment']>;

export interface Input extends PostSegmentPathParams {
  apiVersion?: string;
  body: PostSegmentRequestBody;
}

export async function postSegment(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/segments/{projectKey}/{environmentKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
